// src/components/shared/WskIndicator.jsx
// Indicador discreto de saude WebSocket para a sidebar.

import React, { useState, useEffect } from 'react';
import { apiFetch } from '../../apiFetch';

function avaliarSaude(data) {
  if (!data) return 'warn';

  const temClienteAberto = (data.clients || []).some(c => c.readyState === 'OPEN');
  const temMasterList = data.masterClients && Object.keys(data.masterClients).length > 0;
  const temMaster = Boolean(data.masterClient) || temMasterList;

  if (data.totalClients === 0 || !temClienteAberto || !temMaster) return 'warn';
  return 'ok';
}

export default function WskIndicator({ collapsed }) {
  const [saude, setSaude] = useState(null);

  useEffect(() => {
    let cancelado = false;

    async function checar() {
      try {
        const data = await apiFetch('/api/websocket/status');
        if (!cancelado) setSaude(avaliarSaude(data));
      } catch {
        if (!cancelado) setSaude('warn');
      }
    }

    checar();
    const intervalo = setInterval(checar, 15000);

    return () => {
      cancelado = true;
      clearInterval(intervalo);
    };
  }, []);

  const cor = saude === 'ok'
    ? 'rgba(74, 222, 128, 0.85)'
    : saude === 'warn'
      ? 'rgba(251, 191, 36, 0.85)'
      : 'rgba(148, 163, 184, 0.4)';

  const tooltip = saude === 'ok'
    ? 'WebSocket: conexao saudavel'
    : saude === 'warn'
      ? 'WebSocket: verifique a conexao'
      : 'WebSocket: verificando...';

  return (
    <div
      title={tooltip}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: collapsed ? 0 : '8px',
        padding: collapsed ? '8px 0' : '6px 12px',
        justifyContent: collapsed ? 'center' : 'flex-start',
        cursor: 'default',
        userSelect: 'none',
      }}
    >
      <div style={{
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        background: cor,
        flexShrink: 0,
        boxShadow: saude === 'ok'
          ? '0 0 6px rgba(74, 222, 128, 0.5)'
          : saude === 'warn'
            ? '0 0 6px rgba(251, 191, 36, 0.5)'
            : 'none',
        transition: 'background 0.4s, box-shadow 0.4s',
      }} />

      {!collapsed && (
        <span style={{
          fontSize: '12px',
          color: 'rgba(148, 163, 184, 0.7)',
          fontWeight: 500,
          letterSpacing: '0.05em',
        }}>
          WSK
        </span>
      )}
    </div>
  );
}
